import { render, staticRenderFns } from "./AppButtonAddCancelAddTreament.vue?vue&type=template&id=12435d01&scoped=true&"
import script from "./AppButtonAddCancelAddTreament.vue?vue&type=script&lang=ts&"
export * from "./AppButtonAddCancelAddTreament.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonAddCancelAddTreament.vue?vue&type=style&index=0&id=12435d01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12435d01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
